export default __webpack_public_path__ + "static/media/to-go.f89a9b55.png";